import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { servicedeskKnowledgeBaseLinkedSourcesResource } from '@jira/router-resources__service-desk-knowledge-base/src/servicedeskKnowledgeBaseLinkedSourcesResource.tsx';
import { servicedeskKnowledgeBaseServerLinkStatusResource } from '@jira/router-resources__service-desk-knowledge-base/src/servicedeskKnowledgeBaseServerLinkStatusResource.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getServiceDeskNavigationResources } from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { knowledgeHubSetupRoute } from '@jira/router-routes__servicedesk-knowledge-hub-routes/src/knowledgeHubSetupRoute.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
// eslint-disable-next-line jira/restricted/@jira+servicedesk__common-toPackageName
import { APP_NAMES, toPackageName } from '@jira/servicedesk__common/src/toPackageName.tsx';
import { projectIdResource } from '@jira/router-resources__knowledge-hub/src/projectIdResource.tsx';
import { resourceWithCondition } from '@jira/router-resources__utils/src/resourceWithCondition.tsx';
import { kbTopicsResource } from '@jira/router-resources__knowledge-hub/src/kbTopicsResource.tsx';
import { knowledgeHubBrowseAllArticlesKBTypeCheckerResource } from '@jira/router-resources__knowledge-hub/src/knowledgeHubBrowseAllArticlesKBTypeCheckerResource.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import type { Route } from '@atlassian/react-resource-router';
import { getKnowledgeHubResources } from './common/getKnowledgeHubResources.tsx';
import ServiceDeskKnowledgeHubSetup, {
	LazyServicedeskKnowledgeHubSetup,
} from './ui/setup/index.tsx';
import { getKBExperimentResources } from './common/getKBExperimentResources.tsx';

export const knowledgeHubSetupRouteEntry: Route = createEntry(knowledgeHubSetupRoute, () => ({
	group: 'servicedesk',
	// eslint-disable-next-line no-restricted-syntax
	component: ServiceDeskKnowledgeHubSetup,
	layout: serviceProjectLayout,
	navigation: {
		menuId: MenuIdProjects,
	},
	resources: [
		...getServiceDeskNavigationResources(),
		...getKnowledgeHubResources(),
		getConsolidationStateResource(),
		...getKBExperimentResources(),
		servicedeskKnowledgeBaseServerLinkStatusResource,
		servicedeskKnowledgeBaseLinkedSourcesResource,
		resourceWithCondition(() => fg('jsm-kb-articles-functional'), projectIdResource),
		resourceWithCondition(() => fg('jsm-kb-articles-functional'), kbTopicsResource),
		resourceWithCondition(
			() => fg('jsm-kb-articles-functional'),
			knowledgeHubBrowseAllArticlesKBTypeCheckerResource,
		),
	],
	forPaint: [LazyAtlassianNavigation, LazyServicedeskKnowledgeHubSetup],
	meta: {
		reporting: {
			id: APP_NAMES.KB_SETUP,
			packageName: toPackageName(APP_NAMES.KB_SETUP),
			teamName: 'jsm-nebula',
		},
	},
	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
